import React, { useState, useEffect } from "react";
import { X, Gift } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";
import { safeStorage } from "@/lib/safeStorage";

export default function NewsletterPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (safeStorage.getItem("bv_newsletter_dismissed")) return;
    const t = setTimeout(() => setShow(true), 30000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    safeStorage.setItem("bv_newsletter_dismissed", "1");
    setShow(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) {
      toast.error("Fogadd el az adatvédelmi tájékoztatót.");
      return;
    }
    setLoading(true);
    try {
      await subscribeNewsletter(email, "popup");
      toast.success("🎯 Sikeresen feliratkoztál a Bónusz Riasztóra!");
      close();
    } catch {
      toast.error("Hiba történt.");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-up" data-testid="newsletter-popup">
      <div className="glass-strong rounded-2xl border border-gold/30 max-w-md w-full p-6 relative">
        <button
          onClick={close}
          className="absolute top-3 right-3 text-white/50 hover:text-white"
          aria-label="Bezár"
          data-testid="popup-close"
        >
          <X size={20} />
        </button>
        <div className="text-center mb-4">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-3 animate-glow">
            <Gift size={28} className="text-gold" />
          </div>
          <h3 className="text-2xl font-display font-black text-white">Bónusz Riasztó 🎯</h3>
          <p className="text-white/70 text-sm mt-2">
            Légy az első, aki értesül az új exkluzív bónuszokról és promóciós kódokról! Heti egy email, semmi spam.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@pelda.hu"
            className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white outline-none focus:ring-2 focus:ring-gold/50"
            data-testid="popup-email"
          />
          <label className="flex items-start gap-2 text-xs text-white/60">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="popup-consent" />
            <span>Elfogadom az adatvédelmi tájékoztatót, és kérek időszakos email értesítéseket.</span>
          </label>
          <button type="submit" disabled={loading} className="w-full gold-btn rounded-lg py-3 disabled:opacity-50" data-testid="popup-submit">
            {loading ? "..." : "Feliratkozom"}
          </button>
        </form>
      </div>
    </div>
  );
}
